<template>
  <m-dialog
    ref="dlg"
    @save="save"
    :title="periode && periode.periode_id ? 'Ubah Periode' : 'Tambah Periode'"
  >
    <v-container>
      <v-row row wrap justify="center" align="center">
        <v-col cols="12" sm="10" md="7" lg="7" xl="7">
          <v-form @submit.prevent data-vv-scope="form" lazy-validation>
            <v-row row wrap>
              <v-col cols="12" sm="12" md="12" lg="12" class="py-0">
                <label class="caption mb-2">Nama Periode</label>
                <v-text-field
                  dense
                  single-line
                  outlined
                  label="Nama"
                  v-model="periode.nama"
                  hint="Masukkan Nama Periode"
                  data-vv-name="nama"
                  data-vv-as="Nama"
                  v-validate.persist="'required'"
                  rows="2"
                  :error-messages="errors.collect('form.nama')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6" class="py-0">
                <label class="caption mb-2">Tanggal Awal</label>
                <m-datepicker
                  dense
                  single-line
                  outlined
                  label="Tanggal Awal"
                  v-model="tanggalAwal"
                  hint="Masukkan Tanggal Awal Periode"
                  data-vv-name="tanggalAwal"
                  data-vv-as="Tanggal Awal"
                  v-validate.persist="'required'"
                  :error-messages="errors.collect('form.tanggalAwal')"
                ></m-datepicker>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="6"
                lg="6"
                v-show="rangeDate"
                class="py-0"
              >
                <label class="caption mb-2">Tanggal Akhir</label>
                <m-datepicker
                  dense
                  single-line
                  outlined
                  label="Tanggal Akhir"
                  v-model="tanggalAkhir"
                  :min="tanggalAwal"
                  hint="Masukkan Tanggal Akhir Periode"
                  data-vv-name="tanggalAkhir"
                  data-vv-as="Tanggal Akhir"
                  v-validate.persist="'required'"
                  :error-messages="errors.collect('form.tanggalAkhir')"
                ></m-datepicker>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </m-dialog>
</template>

<script>
export default {
  $_veeValidate: {
    validator: "new"
  },

  data() {
    return {
      rangeDate: true,
      tanggalAwal: null,
      tanggalAkhir: null,
      periode: {},
      defPeriode: {
        tanggal: null,
        keterangan: null
      }
    };
  },
  mounted() {},
  methods: {
    // eslint-disable-next-line
    open(obj) {
      this.periode = obj
        ? {
            ...obj,
            ...(this.tanggalAwal = obj.tgl_mulai),
            ...(this.tanggalAkhir = obj.tgl_selesai)
          }
        : {
            ...this.defPeriode,
            ...(this.tanggalAwal = null),
            ...(this.tanggalAkhir = null)
          };
      this.$validator.reset();
      return this.$refs.dlg.open();
    },
    save() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          this.periode.tgl_mulai = this.tanggalAwal;
          this.periode.tgl_selesai = this.tanggalAkhir;
          this.$store
            .dispatch("periode/form", {
              organisasi_id: this.organisasi_id || this.tenant_id,
              obj: this.periode
            })

            .then(() => {
              this.$refs.dlg.resolve();
            })
            .catch(e => e);
        })
        .catch(e => e);
    }
  }
};
</script>
